import React from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import uuid from 'uuid/v1';
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  MenuItem,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  Select,
  Switch,
  TextField,
  Typography,
  FormControlLabel,
  Stack
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { cloneDeep, isEmpty, isEqual, map, find } from 'lodash';
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AnnotationTemplatesCollection, {
  LIBRARY_ICON_TYPES
} from '../../../api/AnnotationTemplates/AnnotationTemplates';
import Projects from '../../../api/Projects/Projects';
import Videos, { VIDEO_TYPES } from '../../../api/Videos/Videos';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';
import ShowListIconsFontawesome from '../../components/ShowListIconsFontawesome';

import TemplateConfigLocationModal from '../TemplateConfigLocationModal';
import ConfigurationsConnectors from '../../../api/ConfigurationsConnectors/ConfigurationsConnectors';
import * as videoOps from '../../../api/Videos/video-operations';

const MapsAdvancedAnnotationDirectButtons = ({
  annotationTemplateList,
  listComponentsAdvanced,
  loading,
  projectList,
  settingsAdvanced,
  setSettingsAdvanced,
  setListComponentsAdvanced,
  user,
  videoList,
  configConnectorsList
}) => {
  const optionsAnnotationCreate = [
    'Solo geometría en anotaciones',
    'Solo geometria en anotaciones y base de datos',
    'Total en anotaciones',
    'Total en anotaciones y base de datos'
  ];

  const [currentCoords, setCurrentCoords] = React.useState([]);

  const {
    projectId,
    videoId,
    savingSystem,
    intervalTime,
    enableEditTemplate,
    enableBaseDataTemplate,
    showConsultingData = false,
    limitDataConsulting = '50',
    configConnectors = []
  } = settingsAdvanced.directButtons;
  let indexOption = 3;
  if (!enableEditTemplate && !enableBaseDataTemplate) indexOption = 0;
  else if (!enableEditTemplate && enableBaseDataTemplate) indexOption = 1;
  else if (enableEditTemplate && !enableBaseDataTemplate) indexOption = 2;

  const [nameComponent, setNameComponent] = React.useState(
    listComponentsAdvanced.AnnotationDirectButtons.name
  );
  const projectInitial = isEmpty(projectId) ? {} : projectList.find(item => item._id === projectId);
  const videoInitial = isEmpty(videoId) ? {} : videoList.find(item => item._id === videoId);

  const [projectSelect, setProjectSelect] = React.useState(projectInitial);
  const videosFromProjectInitial = videoList.filter(item => item.project === projectId);
  const [videosFromProject, setVideosFromProject] = React.useState(videosFromProjectInitial);
  const [isNewVideoChecked, setIsNewVideoChecked] = React.useState(isEmpty(videoId));
  const [systemSelected, setSystemSelected] = React.useState(savingSystem);
  const [intervalTimeLocal, setIntervalTimeLocal] = React.useState(intervalTime);
  const [videoSelect, setVideoSelect] = React.useState(videoInitial);
  const templatesInitial = isEmpty(videoInitial) ? [] : videoInitial.annotationTemplates;
  const [templateSeleted, setTemplateSeleted] = React.useState(
    templatesInitial.map(index => index._id)
  );
  const [configConnectorsState, setConfigConnectorsState] = React.useState(configConnectors);

  const typeVideoOptions = Object.values(VIDEO_TYPES.properties);
  const [typeVideo, setTypeVideo] = React.useState(typeVideoOptions[0].value);

  const [openModal, setOpenModal] = React.useState(false);
  const [iconFontawesome, setIconFontawesome] = React.useState(
    listComponentsAdvanced.AnnotationDirectButtons.iconFontawesome
  );
  const [iconSvg, setIconSvg] = React.useState(
    listComponentsAdvanced.AnnotationDirectButtons.iconSvg
  );
  const [libraryIcon, setLibraryIcon] = React.useState(
    listComponentsAdvanced.AnnotationDirectButtons.libraryIcon
  );
  // const [isConfigBBDDTemplate, setIsConfigBBDDTemplate] = React.useState(false);
  const [optionAnnotationSelected, setOptionAnnotationSelected] = React.useState(
    optionsAnnotationCreate[indexOption]
  );

  const [isShowConsultingData, setIsShowConsultingData] = React.useState(showConsultingData);
  const [limitData, setLimitData] = React.useState(limitDataConsulting);
  const savingSystemOptions = [
    {
      name: 'Tiempo incremental',
      value: 'incremental'
    },
    {
      name: 'Localización más cercana',
      value: 'location'
    },
    {
      name: 'Tiempo gps',
      value: 'gpsTime'
    }
  ];

  const handleIconSelected = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setIconFontawesome(elementIcon);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        AnnotationDirectButtons: {
          ...listComponentsAdvanced.AnnotationDirectButtons,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      });
    }

    if (library === LIBRARY_ICON_TYPES.SVG) {
      setIconSvg(elementIcon.url);
      setIconFontawesome(elementIcon.name);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        AnnotationDirectButtons: {
          ...listComponentsAdvanced.AnnotationDirectButtons,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      });
    }
    setLibraryIcon(library);
  };

  const handleChangeInterval = value => {
    if (value === '') {
      setIntervalTimeLocal('');
      setSettingsAdvanced(prev => ({
        ...prev,
        directButtons: {
          ...prev.directButtons,
          intervalTime: ''
        }
      }));
    } else if (Number.isNaN(value) || value < 0) {
      Bert.alert('You need to enter a valid number for the interval', 'danger');
    } else {
      setIntervalTimeLocal(value);
      setSettingsAdvanced(prev => ({
        ...prev,
        directButtons: {
          ...prev.directButtons,
          intervalTime: value
        }
      }));
    }
  };

  const generateRandomId = length => {
    return Array.from({ length }, () => Math.random().toString(36)[2]).join('');
  };

  const annotationTemplates =
    !isEmpty(templateSeleted) &&
    annotationTemplateList
      .filter(element => templateSeleted.includes(element._id))
      .map(({ deleted, owner, ...rest }) => rest);

  const newVideoInitial = {
    annotationTemplates,
    controlPoints: {},
    coordinatesDataType: 'point',
    description: '',
    geometryFileName: '',
    _id: generateRandomId(18),
    latLng0: currentCoords,
    logFileName: '',
    name: 'nuevo video',
    noCoordinates: true,
    project: projectId,
    tags: [],
    track: {},
    type: typeVideoOptions[0].value,
    url: 'https://sd1.d3.ipsilum.com/video/output/1min_video.mp4'
  };

  const [videoToSave, setVideoToSave] = React.useState(newVideoInitial);

  const getCurrentCoords = () => {
    if (navigator.geolocation) {
      const success = position => {
        const latitud = position.coords.latitude;
        const longitud = position.coords.longitude;
        const coords = [longitud, latitud];
        setCurrentCoords(coords);
        setVideoToSave(prev => ({
          ...prev,
          latLng0: coords
        }));
      };
      navigator.geolocation.getCurrentPosition(success, msg => {
        console.error(msg);
      });
    }
  };

  const handleChangeType = event => {
    setTypeVideo(event.target.value);
  };

  const handleConfigConnectors = (templateId, configId) => {
    const newConfigConnector = cloneDeep(configConnectorsState);
    const existConfig = !isEmpty(
      find(newConfigConnector, config => isEqual(config.templateId, templateId))
    );
    if (existConfig) {
      const indexConfig = newConfigConnector.indexOf(
        find(newConfigConnector, config => isEqual(config.templateId, templateId))
      );
      newConfigConnector[indexConfig] = { templateId, configId };
    } else newConfigConnector.push({ templateId, configId });

    setConfigConnectorsState(newConfigConnector);
    setSettingsAdvanced(prev => ({
      ...prev,
      directButtons: {
        ...prev.directButtons,
        configConnectors: newConfigConnector
      }
    }));
  };

  const videoOptions = [
    {
      name: '1 minuto',
      url: 'https://sd1.d3.ipsilum.com/video/output/1min_video.mp4',
      value: '1min'
    },
    {
      name: '5 minutos',
      url: 'https://sd1.d3.ipsilum.com/video/output/5min_video.mp4',
      value: '5min'
    },
    {
      name: '15 minutos',
      url: 'https://sd1.d3.ipsilum.com/video/output/15min_video.mp4',
      value: '15min'
    },
    {
      name: '30 minutos',
      url: 'https://sd1.d3.ipsilum.com/video/output/30min_video.mp4',
      value: '30min'
    },

    {
      name: '1 hora',
      url: 'https://sd1.d3.ipsilum.com/video/output/60min_video.mp4',
      value: '60min'
    },
    {
      name: '3 horas',
      url: 'https://sd1.d3.ipsilum.com/video/output/3hours_video.mp4',
      value: '3hours'
    },
    {
      name: '6 horas',
      url: 'https://sd1.d3.ipsilum.com/video/output/6hours_video.mp4',
      value: '6hours'
    },
    {
      name: '12 horas',
      url: 'https://sd1.d3.ipsilum.com/video/output/12hours_video.mp4',
      value: '12hours'
    }
  ];
  const [videoDuration, setVideoDuration] = React.useState('1 minuto');

  const handleProject = async event => {
    const newProject = projectList.find(element => element.name === event.target.value);
    setProjectSelect(newProject);
    setIsNewVideoChecked(false);

    const newVideosFromProject = videoList.filter(item => item.project === newProject._id);
    setVideosFromProject(newVideosFromProject);

    setSettingsAdvanced(prev => ({
      ...prev,
      directButtons: {
        ...prev.directButtons,
        projectId: newProject._id
      }
    }));
  };

  const handleChangeDurationVideo = event => {
    setVideoDuration(event.target.value);
    const newDuration = videoOptions.find(element => element.name === event.target.value);
    setVideoToSave(prev => ({
      ...prev,
      url: newDuration.url
    }));
  };

  const saveVideo = async methodToCall => {
    const videoToSend = videoToSave;
    const userId = user._id;
    setSettingsAdvanced(prev => ({
      ...prev,
      directButtons: {
        ...prev.directButtons,
        videoId: videoToSave._id
      }
    }));
    if (!isEmpty(videoToSend.annotationTemplates) && videoToSend.annotationTemplates !== false) {
      try {
        if (!isNewVideoChecked) {
          const propertiesToDelete = [
            'deleted',
            'createdAt',
            'updatedAt',
            'owner',
            'shared',
            'sharedUser',
            'sharedPrivate',
            'sharedPrivateUser',
            'audience',
            'option'
          ];

          propertiesToDelete.forEach(property => {
            delete videoToSend[property];
          });
        }
        await methodPromise(methodToCall, videoToSend, userId);
        if (isNewVideoChecked) {
          setIsNewVideoChecked(false);
          setVideoSelect(videoToSend);
          setVideosFromProject(prevVideos => [...prevVideos, videoToSend]);

          Bert.alert('video created', 'success');
        } else {
          Bert.alert('video updated', 'success');
        }
      } catch (error) {
        handleErrorInClient(error);
      }
    } else {
      Bert.alert('Seleccionar primero al menos un tipo de plantilla', 'warning');
    }
  };

  const handleChangeAnnotation = item => {
    const currentIndex = templateSeleted.indexOf(item._id);
    const newChecked = [...templateSeleted];

    if (currentIndex === -1) {
      newChecked.push(item._id);
    } else {
      const newConfigConnector = cloneDeep(configConnectorsState);
      if (!isEmpty(newConfigConnector)) {
        const indexSpliceConfig = newConfigConnector.indexOf(
          find(newConfigConnector, newConfig => isEqual(newConfig.templateId, item._id))
        );
        if (!isEqual(indexSpliceConfig, -1)) {
          newConfigConnector.splice(indexSpliceConfig, 1);
          setConfigConnectorsState(newConfigConnector);
          setSettingsAdvanced(prev => ({
            ...prev,
            directButtons: {
              ...prev.directButtons,
              configConnectors: newConfigConnector
            }
          }));
        }
      }
      newChecked.splice(currentIndex, 1);
    }
    const arrayTemplates = annotationTemplateList
      .filter(element => newChecked.includes(element._id))
      .map(({ deleted, ...rest }) => rest);
    setVideoToSave(prev => ({
      ...prev,
      annotationTemplates: arrayTemplates
    }));

    if (!isNewVideoChecked) {
      saveVideo('videos.update');
    }
    setTemplateSeleted(newChecked);
  };

  const handleOptionAnnotation = option => {
    let isEdit = false;
    let isBBDD = false;
    switch (optionsAnnotationCreate.indexOf(option)) {
      case 1:
        isEdit = false;
        isBBDD = true;
        break;
      case 2:
        isEdit = true;
        isBBDD = false;
        break;
      case 3:
        isEdit = true;
        isBBDD = true;
        break;
      default:
        break;
    }
    setSettingsAdvanced(prev => ({
      ...prev,
      directButtons: {
        ...prev.directButtons,
        enableEditTemplate: isEdit,
        enableBaseDataTemplate: isBBDD
      }
    }));
    setOptionAnnotationSelected(option);
  };

  const handleShowConsultingData = isShow => {
    setIsShowConsultingData(isShow);
    setSettingsAdvanced(prev => ({
      ...prev,
      directButtons: {
        ...prev.directButtons,
        showConsultingData: isShow
      }
    }));
  };

  const handleLimitData = limit => {
    setLimitData(limit);
    setSettingsAdvanced(prev => ({
      ...prev,
      directButtons: {
        ...prev.directButtons,
        limitDataConsulting: limit
      }
    }));
  };

  React.useEffect(() => {
    if (!isEmpty(videoToSave)) {
      const annotationTemplatesVideo = videoOps.getAnnotationTemplates(videoToSave);
      if (!isNewVideoChecked && annotationTemplatesVideo !== false) {
        saveVideo('videos.update');
      }
    }
  }, [videoToSave]);

  React.useEffect(() => {
    getCurrentCoords();
    setSettingsAdvanced({
      ...settingsAdvanced,
      directButtons: {
        ...settingsAdvanced.directButtons,
        videoOptions
      }
    });
  }, []);

  React.useEffect(() => {
    if (!loading) {
      if (!isEmpty(projectId)) {
        const initialProject = projectList.find(item => item._id === projectId);
        setProjectSelect(initialProject);
        const initialVideosFromProject = videoList.filter(item => item.project === projectId);
        setVideosFromProject(initialVideosFromProject);
      }
      if (!isEmpty(videoId)) {
        const initialVideo = videoList.find(item => item._id === videoId);
        if (!isEmpty(initialVideo)) {
          setVideoSelect(initialVideo);
          const initialTemplates = initialVideo.annotationTemplates.map(index => index._id);
          setTemplateSeleted(initialTemplates);
        }
      }
    }
  }, [loading]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box display="flex" width="100%">
      <Box display="flex" flexDirection="column" width="50%" gap={1}>
        <Box
          component="form"
          sx={{
            display: 'flex',
            mb: 2,
            width: '100%'
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-required"
            label="Nombre del componente"
            size="small"
            value={nameComponent}
            onChange={event => setNameComponent(event.target.value)}
            mb={2}
            fullWidth
          />
          <IconButton
            onClick={() => setOpenModal(true)}
            style={{
              color: '#2A3F90'
            }}
          >
            {!isEmpty(listComponentsAdvanced.AnnotationDirectButtons.libraryIcon) ? (
              <>
                {libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME && (
                  <FontAwesomeIcon icon={iconFontawesome} />
                )}
                {libraryIcon === LIBRARY_ICON_TYPES.SVG && (
                  <img
                    src={iconSvg}
                    alt={iconFontawesome}
                    style={{ marginRight: '5px', width: '20px', height: '20px' }}
                  />
                )}
              </>
            ) : (
              <EditLocationAltIcon />
            )}
          </IconButton>
          <IconButton
            onClick={() =>
              setListComponentsAdvanced({
                ...listComponentsAdvanced,
                AnnotationDirectButtons: {
                  name: nameComponent,
                  show: listComponentsAdvanced.AnnotationDirectButtons.show
                }
              })
            }
            style={{
              color: '#2A3F90'
            }}
          >
            <SaveIcon />
          </IconButton>
          <ShowListIconsFontawesome
            openModal={openModal}
            setOpenModal={setOpenModal}
            handleIconSelected={handleIconSelected}
            selectedIcon={listComponentsAdvanced.AnnotationDirectButtons.iconFontawesome}
            startLibrary={listComponentsAdvanced.AnnotationDirectButtons.libraryIcon}
            svg={listComponentsAdvanced.AnnotationDirectButtons.iconSvg}
            startCategorySvg={listComponentsAdvanced.AnnotationDirectButtons.cetegorySvg}
          />
        </Box>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-select-label">Proyecto</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Proyecto"
            size="small"
            value={projectSelect?.name || ''}
            onChange={handleProject}
          >
            {projectList.map(item => (
              <MenuItem key={item.name} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Switch
          checked={isNewVideoChecked}
          onChange={() => setIsNewVideoChecked(!isNewVideoChecked)}
          color="secondary"
        />
        {isNewVideoChecked && !isEmpty(videoToSave) ? (
          <>
            <Box display="flex" justifyContent="space-evenly" width="100%" mb={2}>
              <TextField
                id="outlined-required"
                label="Nombre del video"
                size="small"
                value={videoToSave.name}
                onChange={event =>
                  setVideoToSave({
                    ...videoToSave,
                    name: event.target.value
                  })
                }
                mb={2}
                fullWidth
              />
            </Box>
            <Box display="flex" justifyContent="space-evenly" width="100%" mb={2}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Duración</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={videoDuration}
                  label="Duración"
                  onChange={handleChangeDurationVideo}
                  size="small"
                >
                  {videoOptions.map(item => (
                    <MenuItem key={item.name} value={item.name}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Box display="flex" justifyContent="space-evenly" width="100%" mb={2}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={typeVideo}
                  label="Tipo"
                  onChange={handleChangeType}
                  size="small"
                >
                  {typeVideoOptions.map(item => (
                    <MenuItem key={item.name} value={item.value}>
                      {item.humanValue}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </>
        ) : (
          <>
            {!isEmpty(videosFromProject) && (
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel id="demo-select-label">Video</InputLabel>
                <Select
                  labelId="demo-select-label"
                  id="demo-select"
                  label="Video"
                  size="small"
                  value={videoSelect?.name || ''}
                  onChange={event => {
                    const video = videosFromProject.find(
                      element => element.name === event.target.value
                    );
                    const arrayTemplates = video.annotationTemplates.map(index => index._id);
                    if (video) {
                      video.project = projectSelect._id;
                      setVideoSelect(video);
                      setVideoToSave(video);
                      setTemplateSeleted(arrayTemplates);
                      setSettingsAdvanced(prev => ({
                        ...prev,
                        directButtons: {
                          ...prev.directButtons,
                          videoId: video._id,
                          projectId: projectSelect._id,
                          videoOptions,
                          savingSystem,
                          intervalTime
                        }
                      }));
                      setIsNewVideoChecked(false);
                    }
                  }}
                >
                  {videosFromProject.map(item => (
                    <MenuItem key={item.name} value={item.name}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </>
        )}
        {isNewVideoChecked && (
          <Box display="flex" justifyContent="space-evenly" mb={2}>
            <Button variant="outlined" style={{ color: '#2A3F90' }} onClick={getCurrentCoords}>
              Recargar coordenadas
            </Button>
            <Button
              variant="outlined"
              color="success"
              onClick={() => {
                const methodToCall = isNewVideoChecked ? 'videos.insert' : 'videos.update';
                saveVideo(methodToCall);
              }}
            >
              Crear video
            </Button>
          </Box>
        )}
        <Box display="flex" justifyContent="space-evenly" width="100%" mb={2}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Sistema de guardado</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={systemSelected}
              label="Sistema de guardado"
              onChange={event => {
                setSystemSelected(event.target.value);
                setSettingsAdvanced(prev => ({
                  ...prev,
                  directButtons: {
                    ...prev.directButtons,
                    savingSystem: event.target.value
                  }
                }));
              }}
              size="small"
            >
              {savingSystemOptions.map(item => (
                <MenuItem key={item.name} value={item.value}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        {systemSelected === 'incremental' && (
          <Box display="flex" justifyContent="space-evenly" width="100%" mb={2}>
            <TextField
              id="outlined-required"
              label="Introduce un intervalo en segundos"
              size="small"
              value={intervalTimeLocal}
              onChange={event => handleChangeInterval(event.target.value)}
              mb={2}
              fullWidth
            />
          </Box>
        )}
        <Box display="flex" justifyContent="space-evenly" width="100%" mb={2}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Opciones de creación anotaciones</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={optionAnnotationSelected}
              label="Opciones de creación anotaciones"
              size="small"
              onChange={event => handleOptionAnnotation(event.target.value)}
            >
              {optionsAnnotationCreate.map(option => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box width="100%" mb={2}>
          <FormControl style={{ width: '100%' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isShowConsultingData}
                  onChange={event => {
                    handleShowConsultingData(event.target.checked);
                  }}
                />
              }
              label="Visualizar consulta de datos"
            />
          </FormControl>
          {isShowConsultingData && (
            <>
              <TextField
                id="outlined-required"
                label="Limite de registros por consulta"
                size="small"
                value={limitData}
                onChange={event => handleLimitData(event.target.value)}
                style={{ width: '30%', marginRight: '2%' }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={limitData === 'All'}
                    onChange={
                      limitData === 'All'
                        ? () => handleLimitData(limitDataConsulting)
                        : () => handleLimitData('All')
                    }
                  />
                }
                label="Visualizar todos los registros"
              />
            </>
          )}
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" width="40%" sx={{ m: 2 }}>
        <Box display="flex" flexDirection="column" width="75%" spacing={1}>
          <Stack direction="row" display="flex">
            <Typography marginRight="2%">Lista de plantillas de anotaciones</Typography>
            {!isEmpty(annotationTemplates) && !isEmpty(videoSelect) && (
              <TemplateConfigLocationModal
                templateConfiguration={{}}
                handleTemplateConfiguration={() => {}}
                videoSelect={videoSelect}
                showOptionRelation={false}
              />
            )}
          </Stack>
          <div style={{ maxHeight: '50vh', overflow: 'auto' }}>
            <List>
              {annotationTemplateList.map(item => {
                const configElement = find(configConnectorsState, config =>
                  isEqual(config.templateId, item._id)
                );
                return (
                  <Box key={uuid()}>
                    <ListItem key={item._id} button onClick={() => handleChangeAnnotation(item)}>
                      <Checkbox
                        edge="start"
                        checked={templateSeleted?.indexOf(item._id) !== -1}
                        tabIndex={-1}
                        disableRipple
                        sx={{
                          color: '#2A3F90',
                          '&.Mui-checked': {
                            color: '#2A3F90'
                          }
                        }}
                      />
                      <ListItemText primary={item.name} secondary={item.path} />
                    </ListItem>
                    {!isEmpty(configConnectorsList) && templateSeleted?.indexOf(item._id) !== -1 && (
                      <ListItem>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <InputLabel id="select-perfil">Configurations connectors</InputLabel>
                          <Select
                            labelId="select-perfil"
                            id="select-perfil"
                            label="Configurations connectors"
                            size="small"
                            value={!isEmpty(configElement) ? configElement.configId : 'none'}
                            onChange={event => handleConfigConnectors(item._id, event.target.value)}
                          >
                            <MenuItem value="none">--------</MenuItem>
                            {map(configConnectorsList, config => {
                              if (isEqual(config.templateId, item._id))
                                return (
                                  <MenuItem key={config.name} value={config._id}>
                                    {config.name}
                                  </MenuItem>
                                );
                              return '';
                            })}
                          </Select>
                        </FormControl>
                      </ListItem>
                    )}
                  </Box>
                );
              })}
            </List>
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default withTracker(() => {
  const annotationTemplateSub = Meteor.subscribe('annotationTemplates.usersView');
  const projectsSub = Meteor.subscribe('projects');
  const videosSub = Meteor.subscribe('videos.maps');
  const configConnectorsSub = Meteor.subscribe('configurationsConnectors');

  const loading =
    !videosSub.ready() ||
    !projectsSub.ready() ||
    !annotationTemplateSub.ready() ||
    !configConnectorsSub.ready();
  const annotationTemplateList = AnnotationTemplatesCollection.find({
    deleted: { $eq: 'no' }
  }).fetch();
  const projectList = Projects.find({ deleted: { $eq: 'no' } }, { sort: { name: 1 } }).fetch();
  const videoList = Videos.find({}, { sort: { name: 1 } }).fetch();
  const configConnectorsList = ConfigurationsConnectors.find({}, { sort: { name: 1 } }).fetch();
  return {
    loading,
    annotationTemplateList,
    projectList,
    videoList,
    configConnectorsList
  };
})(MapsAdvancedAnnotationDirectButtons);

MapsAdvancedAnnotationDirectButtons.defaultProps = {
  annotationTemplateList: [],
  configConnectorsList: [],
  loading: true
};
MapsAdvancedAnnotationDirectButtons.propTypes = {
  annotationTemplateList: PropTypes.array,
  loading: PropTypes.bool,
  settingsAdvanced: PropTypes.object.isRequired,
  setSettingsAdvanced: PropTypes.func.isRequired,
  listComponentsAdvanced: PropTypes.object.isRequired,
  setListComponentsAdvanced: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  videoList: PropTypes.array.isRequired,
  projectList: PropTypes.array.isRequired,
  configConnectorsList: PropTypes.array
};
